export default {"src":"/_next/static/media/placeholder.d65d597c.svg","height":176,"width":264,"blurWidth":0,"blurHeight":0};